export const products = [
  {
    name: "aimovig",
    logo: "aimovig.svg",
    questionnaire: ["Residency", "HouseholdSize", "IncomeLevel", "Insurance"],
    group: 3,
    hidden: [],
    householdIncomeQuestion: 2,
  },
  {
    name: "amjevita",
    logo: "amjevita.svg",
    questionnaire: ["Residency", "HouseholdSize", "IncomeLevel", "Insurance"],
    group: 3,
    hidden: [],
    householdIncomeQuestion: 2,
  },
  {
    name: "aranesp",
    logo: "aranesp.svg",
    questionnaire: ["Residency", "HouseholdSize", "IncomeLevel", "Insurance"],
    group: 0,
    hidden: [],
    householdIncomeQuestion: 1,
  },
  {
    name: "avsola",
    logo: "avsola.svg",
    questionnaire: ["Residency", "HouseholdSize", "IncomeLevel", "Insurance"],
    group: 0,
    hidden: [],
    householdIncomeQuestion: 2,
  },
  {
    name: "blincyto",
    logo: "blincyto.svg",
    questionnaire: ["Residency", "HouseholdSize", "IncomeLevel", "Insurance"],
    group: 0,
    hidden: [],
    householdIncomeQuestion: 1,
  },
  {
    name: "corlanor",
    logo: "corlanor.svg",
    questionnaire: ["Residency", "HouseholdSize", "IncomeLevel", "Insurance"],
    group: 3,
    hidden: [],
    householdIncomeQuestion: 2,
  },
  {
    name: "enbrel",
    logo: "enbrel.svg",
    questionnaire: ["Residency", "HouseholdSize", "IncomeLevel", "Insurance"],
    group: 3,
    hidden: [],
    householdIncomeQuestion: 2,
  },
  {
    name: "epogen",
    logo: "epogen.svg",
    questionnaire: [
      "Dialysis",
      "Residency",
      "HouseholdSize",
      "IncomeLevel",
      "Insurance",
    ],
    group: 10,
    hidden: ["eligible", "enroll", "contact", "download"],
    householdIncomeQuestion: 2,
  },
  {
    name: "evenity",
    logo: "evenity.svg",
    questionnaire: ["Residency", "HouseholdSize", "IncomeLevel", "Insurance"],
    group: 0,
    hidden: [],
    householdIncomeQuestion: 2,
  },
  {
    name: "imdelltra",
    logo: "imdelltra.svg",
    questionnaire: ["Residency", "HouseholdSize", "IncomeLevel", "Insurance"],
    group: 0,
    hidden: [],
    householdIncomeQuestion: 1,
  },
  {
    name: "imlygic",
    logo: "imlygic.svg",
    questionnaire: ["Residency", "HouseholdSize", "IncomeLevel", "Insurance"],
    group: 0,
    hidden: [],
    householdIncomeQuestion: 1,
  },
  {
    name: "kanjinti",
    logo: "kanjinti.svg",
    questionnaire: ["Residency", "HouseholdSize", "IncomeLevel", "Insurance"],
    group: 0,
    hidden: [],
    householdIncomeQuestion: 1,
  },
  {
    name: "kyprolis",
    logo: "kyprolis.svg",
    questionnaire: ["Residency", "HouseholdSize", "IncomeLevel", "Insurance"],
    group: 0,
    hidden: [],
    householdIncomeQuestion: 1,
  },
  {
    name: "lumakras",
    logo: "lumakras.svg",
    questionnaire: ["Residency", "HouseholdSize", "IncomeLevel", "Insurance"],
    group: 0,
    hidden: [],
    householdIncomeQuestion: 1,
  },
  {
    name: "mvasi",
    logo: "mvasi.svg",
    questionnaire: ["Residency", "HouseholdSize", "IncomeLevel", "Insurance"],
    group: 0,
    hidden: [],
    householdIncomeQuestion: 1,
  },
  {
    name: "neulasta",
    logo: "neulasta.svg",
    questionnaire: ["Residency", "HouseholdSize", "IncomeLevel", "Insurance"],
    group: 0,
    hidden: ["eligible", "enroll", "contact", "download"],
    householdIncomeQuestion: 1,
  },
  {
    name: "neupogen",
    logo: "neupogen.svg",
    questionnaire: ["Residency", "HouseholdSize", "IncomeLevel", "Insurance"],
    group: 0,
    hidden: ["eligible", "enroll", "contact", "download"],
    householdIncomeQuestion: 1,
  },
  {
    name: "nplate",
    logo: "nplate.svg",
    questionnaire: ["Residency", "HouseholdSize", "IncomeLevel", "Insurance"],
    group: 0,
    hidden: [],
    householdIncomeQuestion: 1,
  },
  {
    name: "otezla",
    logo: "otezla.svg",
    questionnaire: ["Residency", "HouseholdSize", "IncomeLevel", "Insurance"],
    group: 3,
    hidden: [],
    householdIncomeQuestion: 2,
  },
  {
    name: "parsabiv",
    logo: "parsabiv.svg",
    questionnaire: ["Residency", "HouseholdSize", "IncomeLevel", "Insurance"],
    group: 0,
    hidden: [],
    householdIncomeQuestion: 2,
  },
  {
    name: "prolia",
    logo: "prolia.svg",
    questionnaire: ["Residency", "HouseholdSize", "IncomeLevel", "Insurance"],
    group: 0,
    hidden: [],
    householdIncomeQuestion: 2,
  },
  {
    name: "repatha",
    logo: "repatha.svg",
    questionnaire: ["Residency", "HouseholdSize", "IncomeLevel", "Insurance"],
    group: 3,
    hidden: [],
    householdIncomeQuestion: 2,
  },
  {
    name: "riabni",
    logo: "riabni.svg",
    questionnaire: ["Residency", "HouseholdSize", "IncomeLevel", "Insurance"],
    group: 0,
    hidden: [],
    householdIncomeQuestion: 1,
  },
  {
    name: "sensipar",
    logo: "sensipar.svg",
    questionnaire: ["Residency", "HouseholdSize", "IncomeLevel", "Insurance"],
    group: 11,
    hidden: ["eligible", "enroll", "contact", "download"],
    householdIncomeQuestion: 1,
  },
  {
    name: "tezspire",
    logo: "tezspire.svg",
    questionnaire: ["Residency", "HouseholdSize", "IncomeLevel", "Insurance"],
    group: 0,
    hidden: [],
    householdIncomeQuestion: 1,
  },
  {
    name: "tavneos",
    logo: "tavneos.svg",
    questionnaire: ["Residency", "HouseholdSize", "IncomeLevel", "Insurance"],
    group: 0,
    hidden: [],
    householdIncomeQuestion: 1,
  },
  {
    name: "vectibix",
    logo: "vectibix.svg",
    questionnaire: ["Residency", "HouseholdSize", "IncomeLevel", "Insurance"],
    group: 0,
    hidden: [],
    householdIncomeQuestion: 1,
  },
  {
    name: "xgeva",
    logo: "xgeva.svg",
    questionnaire: ["Residency", "HouseholdSize", "IncomeLevel", "Insurance"],
    group: 0,
    hidden: [],
    householdIncomeQuestion: 1,
  },
];

export const filterProducts = products.filter((product) => {
  if (
    product.name.toLocaleLowerCase() === "amjevita" ||
    product.name.toLocaleLowerCase() === "avsola" ||
    product.name.toLocaleLowerCase() === "kanjinti" ||
    product.name.toLocaleLowerCase() === "mvasi" ||
    product.name.toLocaleLowerCase() === "riabni"
  ) {
    return false;
  }
  return true;
});

export const formsFilteredProducts = products.filter(
  (product) => product.name !== "amjevita"
);


